import { Box, Image, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { InboxMessageCategory } from '../state';

function InboxEmptyCategory({ type }: { type: InboxMessageCategory }) {
  return (
    <Box alignItems="center">
      <Image
        name="common.NotificationBell"
        width={80}
        height={80}
        marginVertical="space-600"
      />
      <Box gap="space-400">
        <Text
          variant="h6"
          color="darkSurfacePrimary"
          locNS="inbox"
          locKey={`${type}_empty_title`}
          textAlign="center"
        />
        <Text
          variant="body-s"
          color="darkSurfacePrimary"
          locNS="inbox"
          locKey={`${type}_empty_description`}
          textAlign="center"
        />
      </Box>
    </Box>
  );
}

export default memo(InboxEmptyCategory);
